import React, {useState, useRef, useEffect, useCallback} from "react";
import ReactDOM from "react-dom";
import Select from "react-select";
import { useMediaQuery } from "@react-hook/media-query";

import StepHeader from "./stepParts/StepHeader";
import {
  CALCULATOR_TYPES,
  getCalculatorType, hasShareParam,
  rewriteSelectIds,
  stepStates,
} from "../../services/helpers";
import HypoTypeBlock from "./stepParts/HypoTypeBlock";
import StepSidebar from "./stepParts/StepSidebar";
import {
  setField,
  mortgageCalcAction,
  getBankByIdAction,
  affordCalcAction,
} from "../../store/actions/calculatorActions";
import LoadingModal from "../modals/LoadingModal";
import { mainMediaMobile } from "../../services/helpers";
import { useSelector } from "react-redux";
import { gtm } from "../../services/gtm";
import BankCard from "../summary/BankCard";
import {getStep5HeaderSummary} from "../../services/stepHelpers";
import {getMortgageProvider} from "../../services/calculationsApi";
import {FormattedMessage, useIntl} from "react-intl";

const rentevasteDropdownStyles = {
    control: (provided) => ({
        ...provided,
        minHeight: "50px",
    }),

    indicatorSeparator: () => ({
        display: "none",
    }),
};

const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop + 250);

function Step5({ stepNumber, state, openStep, dispatch }) {
    const intl = useIntl();
    const [stepHeaderSummary, setStepHeaderSummary] = useState('');
    const [hypoType, setHypoType] = useState(true);
    const [handledHasShareParam, SetHandledHasShareParam] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const {Woning, SelectedMortgageProvider, MortgageType, IsNieuwbouw, RentevastePeriode} = useSelector((state) => state.calculator);
    const [rentevastePeriod, setRentevastePeriod] = useState();
    const [sidebarVisibility, setSidebarVisibility] = useState(false);
    const [sidebarType, setSidebarType] = useState();
    const mediaMatches = useMediaQuery(mainMediaMobile);
    const myRef = useRef(null);

    const yearLabel = intl.formatMessage({id: 'step5.year', defaultMessage: 'jaar'})

    const options = [
      { value: 5, label: `5 ${yearLabel}` },
      { value: 10, label: `10 ${yearLabel}`},
      { value: 15, label: `15 ${yearLabel}` },
      { value: 20, label: `20 ${yearLabel}` },
      { value: 30, label: `30 ${yearLabel}` },
    ];


  const onBestDealCLick = useCallback(async ($event, triggeredByShare) => {
        let setMortgageType = null;
        let setMortgagePeriod = null;
        setIsLoading(true);

        if (triggeredByShare) {
            if (SelectedMortgageProvider) {

                const response = await getMortgageProvider(SelectedMortgageProvider, IsNieuwbouw);
                setMortgageType = response.hypotheekVorm;
                setMortgagePeriod = response.rentevastePeriode;

            } else {
                setRentevastePeriod(options.find((options) => options.value === RentevastePeriode))
                setHypoType(MortgageType !== 'Lineaire_hypotheek')
                setMortgageType = MortgageType;
                setMortgagePeriod = RentevastePeriode;
            }
        } else {
            setMortgageType = hypoType ? "Annuïteitenhypotheek" : "Lineaire_hypotheek";
            setMortgagePeriod = rentevastePeriod?.value;

            if (SelectedMortgageProvider) {
                setMortgageType = SelectedMortgageProvider.hypotheekVorm;
                setMortgagePeriod = SelectedMortgageProvider.rentevastePeriode;
            }
        }

        setStepHeaderSummary(getStep5HeaderSummary(setMortgageType, intl));

        dispatch(setField("MortgageType", setMortgageType));
        dispatch(setField("RentevastePeriode", setMortgagePeriod));

        if (mediaMatches) {
            dispatch(setField("lastActiveStepIndex", stepNumber));
        }

        await dispatch(getBankByIdAction());

        if (Woning > 0) {
            //await dispatch(mortgageCalcAction());
            await dispatch(affordCalcAction(stepNumber, true ,true));
        } else {
            await dispatch(mortgageCalcAction(true));
        }

        await dispatch(setField("summaryWithBanksOpened", true));
        openStep(stepNumber, false, false, true);
        const tagManagerArgs = {
            gtmId: "GTM-T78CX5",
            dataLayer: {
                event: "gtm.calculators",
                eventCategory: "Calculator",
                eventAction: "Hypotheekvorm",
                eventLabel: `${(MortgageType === "Annuïteitenhypotheek" || MortgageType === "Annuiteitenhypotheek") ? 'Annuïteiten' : 'Lineair'}-${setMortgagePeriod}jaar`,
            },
        };


        gtm(tagManagerArgs);


        setTimeout(() => {
            setIsLoading(false);
        }, 1000);
    }, [RentevastePeriode, IsNieuwbouw, MortgageType, SelectedMortgageProvider, rentevastePeriod, setRentevastePeriod, Woning, dispatch, hypoType, mediaMatches, openStep, stepNumber, intl, options]);


    useEffect(() => {
      async function fetchData() {
        await onBestDealCLick(null,true);
      }
      if (hasShareParam() && !handledHasShareParam) {
        fetchData();
        SetHandledHasShareParam(true);
      }
    }, [onBestDealCLick, handledHasShareParam]);


    useEffect(() => {
      if (!SelectedMortgageProvider && state === "active") {
        scrollToRef(myRef);
      }
    }, [SelectedMortgageProvider, state]);


  const toggleSidebar = (type) => {
        setSidebarVisibility(!sidebarVisibility);
        setSidebarType(type);
        let tagManagerArgs;

        if (type === "mortgage-info") {
            const MortgageType = hypoType ? "Annuïteiten" : "Lineair";

            tagManagerArgs = {
                gtmId: "GTM-T78CX5",
                dataLayer: {
                    event: "gtm.virtualPageview",
                    virtualURL: `zelf-berekenen/${getCalculatorType()}/hypotheekvorm-meer-info/${MortgageType}`,
                    virtualTitle: "Hypotheekvorm - " + MortgageType,
                },
            };
        } else {
            tagManagerArgs = {
                gtmId: "GTM-T78CX5",
                dataLayer: {
                    event: "gtm.virtualPageview",
                    virtualURL: `zelf-berekenen/${getCalculatorType()}/hypotheekvorm-meer-info/rentevaste-periode`,
                    virtualTitle: "Hypotheekvorm - Rentevase periode",
                },
            };
        }

        gtm(tagManagerArgs);
        //TagManager.initialize(tagManagerArgs);
    };

    const handleYearChange = (rentevastePeriod) => {
        setRentevastePeriod(rentevastePeriod);
        rewriteSelectIds(
            "interest-year-select__menu-list",
            "interest-year-select"
        );
    };

    const rewriteClasses = () =>  rewriteSelectIds("interest-year-select__menu-list","interest-year-select");

    const handleHypoChange = (value) => {
        setHypoType(value);
        (mediaMatches) && scrollToRef(myRef);
    };

    return (
        <div
            className={`ct-step ${
                state === stepStates.inactive && "ct-step__inactive"
            }
                                 ${
                                     state === stepStates.filled &&
                                     "ct-step__filled"
                                 }
                                 ${
                                     state === stepStates.closed &&
                                     "ct-step__closed"
                                 }`}
        >
            <StepHeader
                title={intl.formatMessage({id: 'step5.headerTitle', defaultMessage: 'Hypotheekvorm'})}
                stepSummary={stepHeaderSummary}
                stepNumber={stepNumber}
                stepState={state}
                openStep={openStep}
            />

            <div
                className={`ct-step__body ${
                    state === stepStates.active ? "ct-step__body-opened" : null
                }`}
            >
                <div>
                    <div className="ct-step__body-primary-question">
                      {!SelectedMortgageProvider ? (
                        <FormattedMessage
                        id="step5.selectMortgageType"
                        defaultMessage="Kies een hypotheekvorm*"
                        />
                      ) : (
                        <FormattedMessage
                        id="step5.selectedInterestRate"
                        defaultMessage="Gekozen rente"
                        />
                      )}

                    </div>
                    {SelectedMortgageProvider && (
                        <div className="ct-step__body-tip">
                            <FormattedMessage id={'step5.selectedInterestRate.tip'} defaultMessage={'Om in aanmerking te komen voor hypotheekrenteaftrek, kun je een annuïteitenhypotheek of een lineaire hypotheek afsluiten.'} />
                        </div>
                    )}
                    {!SelectedMortgageProvider && (
                        <div
                            className="ct-step__hypo-type-link"
                            onClick={() => toggleSidebar("mortgage-info")}
                            role="button"
                        >
                          <FormattedMessage id={'step5.selectMortgageType.moreInformation'} defaultMessage={'Niet zeker welke hypotheekvorm bij je past? Lees meer over de annuïteitenhypotheek en de lineaire hypotheek.'} />

                        </div>
                    )}
                </div>
                {SelectedMortgageProvider && (
                    <BankCard
                        isMain={true}
                        bankData={SelectedMortgageProvider}
                    />
                )}

                {!SelectedMortgageProvider && (
                    <div>
                        <div className="ct-step__hypo-type-blocks">
                            <HypoTypeBlock
                                title={intl.formatMessage({id: 'step5.mortgageType.annuïteiten.title', defaultMessage: 'Annuïteiten'})}
                                text={intl.formatMessage({id: 'step5.mortgageType.annuïteiten.text', defaultMessage: 'Een annuïteitenhypotheek is een hypotheek waarbij het totale maandbedrag (bestaande uit rente en aflossing) gedurende de rentevaste periode gelijk blijft.'})}
                                active={hypoType}
                                handleHypoChange={handleHypoChange}
                            />

                            <HypoTypeBlock
                                title={intl.formatMessage({id: 'step5.mortgageType.lineair.title', defaultMessage: 'Lineair'})}
                                text={intl.formatMessage({id: 'step5.mortgageType.lineair.text', defaultMessage: 'Een lineaire hypotheek is een hypotheek waarbij je gedurende de looptijd elke maand hetzelfde bedrag aflost. De rente is in het begin het hoogst en loopt gedurende de looptijd af. Je start dus met een hoog maandbedrag.'})}
                                active={!hypoType}
                                handleHypoChange={handleHypoChange}
                            />
                        </div>

                        <div className="ct-step__body-divider" ref={myRef} />

                        <div className="ct-step__body-secondary-questions-block">
                            <div className="ct-step__body-secondary-question">
                              <FormattedMessage id={'step5.determineInterestRatePeriod'} defaultMessage={'Bepaal je rentevaste periode*'} />
                            </div>

                            <div className="ct-step__body-tip">
                              <FormattedMessage id={'step5.determineInterestRatePeriod.tip'} defaultMessage={'De rentevaste periode is de afgesproken periode waarin de rente gelijk blijft. Het rentepercentage voor jouw hypotheek kun je voor verschillende rentevaste perioden vastzetten.'} />
                            </div>

                            <div
                                className="ct-step__hypo-type-link"
                                onClick={() => toggleSidebar("period")}
                            >
                              <FormattedMessage id={'step5.determineInterestRatePeriod.link'} defaultMessage={'Lees meer over rentevaste periode'} />
                            </div>
                        </div>

                        <div className="ct-step__year-select">
                            <Select
                                value={rentevastePeriod}
                                isSearchable={false}
                                onChange={handleYearChange}
                                onMenuOpen={rewriteClasses}
                                className={"interest-year-select"}
                                classNamePrefix={"interest-year-select"}
                                styles={rentevasteDropdownStyles}
                                options={options}
                                placeholder={intl.formatMessage({ id: 'step5.determineInterestRatePeriod.select', defaultMessage: 'Selecteren'})}
                            />
                        </div>
                    </div>
                )}
                <div className="ct-step__best-deal">
                    <button
                        onClick={onBestDealCLick}
                        disabled={
                            !SelectedMortgageProvider
                                ? !rentevastePeriod
                                : false
                        }
                        className={`ct__button ct-header__afspraak ${
                            !SelectedMortgageProvider
                                ? !rentevastePeriod
                                : false && "ct__button-disabled"
                        }`}
                    >
                      {getCalculatorType() !== CALCULATOR_TYPES.hoeveelKanIkLenen ?
                      <FormattedMessage id={'step5.bestDeal'} defaultMessage={'Bekijk de beste deal'} /> :
                      <FormattedMessage id={'step5.maxMortgage'} defaultMessage={'Bekijk maximale hypotheek'} />
                      }
                    </button>
                </div>

                {sidebarVisibility
                    ? ReactDOM.createPortal(
                          <StepSidebar
                              toggleSidebar={toggleSidebar}
                              sidebarType={sidebarType}
                              intl={intl}
                          />,
                          document.getElementById("sidebar-portal")
                      )
                    : null}

                {isLoading
                    ? ReactDOM.createPortal(
                          <LoadingModal />,
                          document.getElementById("loading-modal-portal")
                      )
                    : null}
            </div>
        </div>
    );
}

export default Step5;
